import { Component, Input, OnChanges } from '@angular/core';

import { TweetDataModel } from '../../../../api/mentions/model/tweet-data.model';

/**
 * Display a rounded box of text with a twitter handle and tweet
 *
 * @mocks Mention Card https://agility-confluence.atlassian.net/wiki/spaces/AM/pages/667098/Mentions+Cards+-+Social+Posts#X-Reply-and-Quote-Post
 * @mocks Mention Details https://agility-confluence.atlassian.net/wiki/spaces/AM/pages/666247/Mentions+View+RHP#X-Reply-and-Quote-Post
 * @mocks Social Posts Feed Card https://agility-confluence.atlassian.net/wiki/spaces/AM/pages/659359/Social+Posts#X-Reply-and-Quote-Posts
 * @mocks Social Post Details https://agility-confluence.atlassian.net/wiki/spaces/AM/pages/659359/Social+Posts#X-Reply-and-Quote-Posts.1
 *
 * For reply and quote tweets, there will be a new original_text field which contains the text of the original tweet that the tweet is responding to.
 * We need to be able to display this when viewing tweets both saved and unsaved
 */
@Component({
    selector: 'agpr-original-tweet',
    templateUrl: './original-tweet-text.component.html',
    styleUrl: './original-tweet-text.component.scss',
    standalone: false
})
export class OriginalTweetComponent implements OnChanges {
    template = {
        show: null,
        originalPosterHandle: '',
        originalPostText: '',
    };

    @Input() tweetData: TweetDataModel;

    ngOnChanges() {
        this.update();
    }

    private update() {
        // conditionally render this component if tweet is a reply or a quote
        const isReplyOrQoute = this.tweetData?.type === 'REPLY' || this.tweetData?.type === 'QUOTE';
        const hasOriginalText = this.tweetData?.originalTweetData?.originalText ? true : false;
        this.template.show = isReplyOrQoute && hasOriginalText ? true : false;

        // set twitter handle of original poster
        this.template.originalPosterHandle = this.tweetData?.originalTweetData?.originalUserHandle ?? '';

        // set original post text
        this.template.originalPostText = this.tweetData?.originalTweetData?.originalText ?? '';
    }
};
